import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_input = _resolveComponent("the-input")!
  const _component_checkbox = _resolveComponent("checkbox")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    class: "large ScopesActions",
    title: _ctx.modalTitle,
    "confirm-button-text": _ctx.modalConfirmButtonText,
    "confirm-button-class": _ctx.isDelete ? 'small red' : undefined,
    "confirm-message": `Вы действительно хотите удалить скоуп (id: ${_ctx.state.id})?`,
    "is-confirm": _ctx.isDelete,
    loading: _ctx.loading,
    onCancel: _ctx.emitCancel,
    onConfirm: _ctx.emitManager
  }, {
    default: _withCtx(() => [
      _createVNode(_component_the_input, {
        class: "w-full",
        value: _ctx.state.scope,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.scope) = $event)),
        "is-invalid": _ctx.state_form$.scope.$error,
        "validation-errors": _ctx.state_form$.scope.$errors,
        placeholder: "Название"
      }, null, 8, ["value", "is-invalid", "validation-errors"]),
      _createVNode(_component_the_input, {
        class: "w-full mt-2",
        value: _ctx.state.description,
        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.description) = $event)),
        "is-invalid": _ctx.state_form$.description.$error,
        "validation-errors": _ctx.state_form$.description.$errors,
        placeholder: "Описание"
      }, null, 8, ["value", "is-invalid", "validation-errors"]),
      _createVNode(_component_checkbox, {
        class: "mt-3",
        value: _ctx.state.isActive,
        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.isActive) = $event)),
        label: "Активен"
      }, null, 8, ["value"])
    ]),
    _: 1
  }, 8, ["title", "confirm-button-text", "confirm-button-class", "confirm-message", "is-confirm", "loading", "onCancel", "onConfirm"]))
}